module.exports = __webpack_public_path__ + "img/bh4.4458db99.jpeg";